import React from 'react'
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import AuthWrapper from './components/AuthWrapper'
import Dashboard from './screens/Dashboard'
import Detail from './screens/Detail'
import Valuation from './screens/Valuations'
import NewValuation from './screens/Valuations/NewValuation'
import ValuationDetail from './screens/Valuations/ValuationDetail'
import Listing from './screens/Listings'
import NewListing from './screens/Listings/NewListing'
import ListingDetail from './screens/Listings/ListingDetail'
import LandingPage from './components/LandingPage'
import PostHogAuthSync from './components/PostHogAuthSync'
import { PropertyMetadataProvider } from './contexts/PropertyMetadataContext'
import MarketAI from './screens/MarketAI'
import Scheduler from './screens/Scheduler'
import Outreach from './screens/Outreach'
import SocialStudio from './screens/SocialStudio'
import { isAdminUser } from './helpers/accessControl'
import VerifyEmail from './components/VerifyEmail'

const AdminOnlyRoute = ({ children }) => {
  const { user } = useAuth()
  return isAdminUser(user) ? children : <Navigate to="/dashboard" replace />
}

function App() {
  return (
    <AuthProvider>
      <PropertyMetadataProvider>
        <PostHogAuthSync />
        <Router>
          <Routes>
            <Route path="/v/:shareToken" element={<ValuationDetail viewMode="shared" />} />
            <Route path="/ukazky/:propertyId" element={<Detail viewMode="demo" />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route
              path="/*"
              element={
                <AuthWrapper>
                  <AuthenticatedRoutes />
                </AuthWrapper>
              }
            />
          </Routes>
        </Router>
      </PropertyMetadataProvider>
    </AuthProvider>
  )
}

const AuthenticatedRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/detail/:propertyId" element={<Detail />} />
      <Route path="/valuations" element={<Valuation />} />
      <Route path="/valuations/new" element={<NewValuation />} />
      <Route path="/valuations/:valuationId/edit" element={<NewValuation />} />
      <Route path="/valuations/:valuationId" element={<ValuationDetail />} />
      <Route path="/listings" element={<Listing />} />
      <Route path="/listings/new" element={<NewListing />} />
      <Route path="/listings/:listingId/edit" element={<NewListing />} />
      <Route path="/listings/:listingId" element={<ListingDetail />} />
      <Route path="/ai" element={<MarketAI />} />
      <Route path="/scheduler" element={<Scheduler />} />
      <Route
        path="/outreach"
        element={<AdminOnlyRoute><Outreach /></AdminOnlyRoute>}
      />
      <Route
        path="/social-studio"
        element={<AdminOnlyRoute><SocialStudio /></AdminOnlyRoute>}
      />
      <Route path="/:offerType" element={<Dashboard />} />
      <Route path="/:offerType/:type" element={<Dashboard />} />
      <Route path="/:offerType/:type/:region" element={<Dashboard />} />
      {/* Add other routes here */}
    </Routes>
  )
}

export default App
